import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Disclaimer } from './pages/Disclaimer';
import { CookieBanner } from './components/ui/CookieBanner';
import { Toaster } from 'sonner';
import { initMetaPixel } from './utils/metaPixel';
import { useContentGuard } from './utils/useContentGuard';
export function App() {
  useContentGuard();
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="31ayvgg9eye65">
      <LanguageProvider data-id="element-1" data-mp="31c9uy3vtszrg">
        <Routes data-id="element-2" data-mp="31ctbbg5tvg3d">
          <Route path="/" element={<Home data-id="element-4" data-mp="2wjqhd6x524mn" />} data-id="element-3" data-mp="2wk0av4he6tx3" />
          <Route path="/privacy" element={<Privacy data-id="element-6" data-mp="2whxaprmizken" />} data-id="element-5" data-mp="2wj8e3qc26q58" />
          <Route path="/terms" element={<Terms data-id="element-8" data-mp="28te1n9vnj3li" />} data-id="element-7" data-mp="28u5xmlt5v3cb" />
          <Route path="/disclaimer" element={<Disclaimer data-id="element-10" data-mp="23vcjqs9ypabm" />} data-id="element-9" data-mp="28suv0pbgc1ms" />
        </Routes>
        <CookieBanner data-id="element-11" data-mp="23u9vyt7xrnzx" />
        <Toaster position="bottom-center" richColors data-id="element-12" data-mp="23v2s7099qv3t" />
        {/* Meta Pixel noscript fallback */}
        <noscript data-id="element-13" data-mp="3ijpc2xoqyt86">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=6810483222354785&ev=PageView&noscript=1" alt="" data-id="element-14" data-mp="3ii4ro0w5cqo1" />
        </noscript>
      </LanguageProvider>
    </BrowserRouter>;
}